import React from "react";
import Select from "react-select";

import "./FilterPanel.css"; // Import your CSS file
import { ColorsData } from "../types";

interface FilterPanelProps {
	danceStyleOptions: { value: number; label: string }[];

	eventTypeOptions: { value: number; label: string }[];
	selectedDanceStyle: { value: number; label: string } | null;
	selectedEventType: { value: number; label: string } | null;
	onSelectDanceStyle: (value: { value: number; label: string } | null) => void;
	legend: ColorsData[] | null;
	onSelectEventType: (value: { value: number; label: string } | null) => void;
}

export const FilterPanel: React.FC<FilterPanelProps> = ({
	danceStyleOptions,
	eventTypeOptions,
	selectedDanceStyle,
	selectedEventType,
	onSelectDanceStyle,
	legend,
	onSelectEventType,
}) => {
	return (
		<div className="scb-filter-panel">
			<div className="dropdown">
				<Select
					styles={{
						control: (baseStyles, state) => ({
							...baseStyles,
							borderRadius: 0,
							border: "1px solid #000 !important",
							height: "66px",
						}),
					}}
					options={danceStyleOptions}
					value={selectedDanceStyle}
					onChange={(value) => onSelectDanceStyle(value)}
					isClearable
					placeholder="Kategorie"
				/>
			</div>

			<div className="dropdown">
				<Select
					styles={{
						control: (baseStyles, state) => ({
							...baseStyles,
							borderRadius: 0,
							border: "1px solid #000 !important",
							height: "66px",
						}),
					}}
					options={eventTypeOptions}
					value={selectedEventType}
					onChange={(value) => onSelectEventType(value)}
					isClearable
					placeholder="Format"
				/>
			</div>
			<div className="scb-event-legend">
				{legend?.map((legendItem, index) => (
					<div
						className="scb-event-legend-item"
						key={index}
					>
						<div
							className="scb-event-legend-color"
							style={{ backgroundColor: legendItem.color }}
						/>
						<h6 className="scb-event-legend-label">{legendItem.label}</h6>
					</div>
				))}
			</div>
		</div>
	);
};
